@if (timeOptions()) {
  <jmkw-select
    [items]="timeOptions()"
    order="original"
    [fontSizeRem]="0.8"
    [initialKey]="initialKey"
    [compareFn]="compareFn"
    (selectionChanged)="onSelectionChangeHandler($event)"
    >
    Forecast Period
  </jmkw-select>
}
